import { ArrowBack } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface BackButtonProps {
  /** URL to navigate to if there's no browser history (optional, defaults to /admin-v2) */
  fallbackUrl?: string;
  /** Custom label for the button (optional, defaults to "Back") */
  label?: string;
  /** Custom className for styling */
  className?: string;
}

/**
 * BackButton component that navigates to the previous page in browser history.
 * Falls back to a specified URL if there's no history available.
 */
export function BackButton({
  fallbackUrl = '/admin-v2',
  label = 'Back',
  className
}: BackButtonProps) {
  const navigate = useNavigate();

  const handleBack = () => {
    // Check if there's history to go back to
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      // No history, use fallback
      navigate(fallbackUrl);
    }
  };

  return (
    <Button
      startIcon={<ArrowBack />}
      onClick={handleBack}
      className={className || 'text-gray-600'}
    >
      {label}
    </Button>
  );
}